import { render, staticRenderFns } from "./AdminFinanciersSettings.vue?vue&type=template&id=6f1b0b71&scoped=true&"
import script from "./AdminFinanciersSettings.vue?vue&type=script&lang=js&"
export * from "./AdminFinanciersSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminFinanciersSettings.vue?vue&type=style&index=0&id=6f1b0b71&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1b0b71",
  null
  
)

export default component.exports